import I18n from 'translations/i18n'

export type Time = {
  hours?: string | number | null
  minutes: string | number
  seconds: string | number
}

export const calculateTimeLeft = (target: string): Time | null => {
  const time = +new Date(target)
  const difference = time - +new Date()
  const minute = 1000 * 60

  const hours =
    Math.floor((difference % (minute * 60 * 24)) / minute) &&
    Math.floor((difference % (minute * 60 * 24)) / (minute * 60))

  const minutes =
    Math.floor((difference % (minute * 60)) / minute) < 10
      ? `0${Math.floor((difference % (minute * 60)) / minute)}`
      : Math.floor((difference % (minute * 60)) / minute)

  const seconds =
    Math.floor((difference / 1000) % 60) < 10
      ? `0${Math.floor((difference / 1000) % 60)}`
      : Math.floor((difference / 1000) % 60)

  if (difference > 0) {
    return {
      hours: parseInt(hours.toString(), 10) > 0 ? hours : null,
      minutes,
      seconds,
    }
  }

  return null
}

export const handleTimer = (time: Time | null): string | null => {
  if (!time || !time.minutes) return null
  if (time.hours) {
    return I18n.t('reminder_time_hours_minutes', { h: time.hours, m: time.minutes })
  }
  return I18n.t('reminder_time_minutes_seconds', { m: time.minutes, s: time.seconds })
}
